export class DynamicTableColumn {
	id?: number; // Needed for time log panel table
	name: string;
	display: string;
	type?: DynamicTableType = DynamicTableType.TEXT;
	format?: string;
	default?: string;
	hide?: boolean; // Hides everywhere unless higher screen resolution options specified; screen < 576px
	hideOnExtraSmallScreen?: boolean; // Hides everywhere unless higher screen resolution options specified; screen < 576px
	hideOnSmallScreen?: boolean; // 576px ≥ screen ≥ 768px
	hideOnMediumScreen?: boolean; // 768px ≥ screen ≥ 992px
	hideOnLargeScreen?: boolean; // 992px ≥ screen ≥ 1200px
	hideOnExtraLargeScreen?: boolean; // 1200px ≥ screen ≥ 1400px
	textColor?: ColorMatch[] = [];
	statusType?: StatusType;
	disableSorting?: boolean;
	sortCaseInsensitive?: boolean;
	align?: AlignmentType = AlignmentType.LEFT;
	event?: any;
	matIcon?: string;
	sortOnPropertyName?: string;
	isDefaultSortColumn?: boolean = false;
	defaultSortDirection?: 'asc' | 'desc';
	width?: number;
	editable?: boolean;
	tooltips?: string[]; // Array of tooltip texts. Some components need one some need more than one;
	toggleAllOn?: boolean;
	toggleAllOff?: boolean;
	maxCount?: number;
	textWrap?: boolean;
}

export class ColorMatch {
	value: any;
	colorHex: string;
}

export enum DynamicTableType {
	DATE = 'date',
	NUMBER = 'number',
	MULTI_CHIP = 'multi-chip',
	MULTI_BADGE = 'multi-badge',
	MULTI_ICON = 'multi-icon',
	COLOR = 'color',
	LINE_WEIGHT = 'line-weight',
	LINE_STYLE = 'line-style',
	TRUE_OR_FALSE = 'trueOrFalse',
	NULL_OR_NOT = 'nullOrNot',
	EMPTY_OR_NOT = 'emptyOrNot',
	ICON_BUTTON = 'icon-button',
	HTML = 'html',
	COUNT = 'count',
	TEXT = 'text',
	SLIDE_TOGGLE = 'slide-toggle',
	ACTIVE_OR_NOT = 'activeOrNot',
}

export enum AlignmentType {
	LEFT = 'left',
	CENTER = 'center',
	RIGHT = 'right',
}

export enum StatusType {
	SUCCESS = 'success',
	WARNING = 'warning',
	DANGER = 'danger',
}

export class IconObject {
	icon: string;
	svgIcon: boolean = false;
	tooltip?: string;
}
